export class WorkerPool {
  constructor() {
    this.pending = new Map()
    this.sequence = 0
    this.worker = new Worker(new URL('./gis.worker.js', import.meta.url))
    this.worker.onmessage = event => {
      const { id, data, error } = event.data
      const job = this.pending.get(id)
      if (!job) return
      this.pending.delete(id)
      error ? job.reject(new Error(error)) : job.resolve(data)
    }
  }
  run(type, payload, transfer = []) {
    return new Promise((resolve, reject) => {
      const id = ++this.sequence
      this.pending.set(id, { resolve, reject })
      this.worker.postMessage({ id, type, payload }, transfer)
    })
  }
  terminate() { this.worker.terminate() }
}
